const HOST_CONFIG = {
  "dev.bijen.app": {
    APP_ENV: "development",
    PUBLIC_WEB_URL: "https://dev.bijen.app",
    PUBLIC_MOBILE_URL: "https://dev.bijen.app",
    PUBLIC_API_URL: "",
    MOBILE_MODE: true,
    ENABLE_NATIVE_BRIDGE: true,
    ENABLE_DEBUG_TOOLS: true,
  },
  "beta.bijen.app": {
    APP_ENV: "beta",
    PUBLIC_WEB_URL: "https://beta.bijen.app",
    PUBLIC_MOBILE_URL: "https://beta.bijen.app",
    PUBLIC_API_URL: "",
    MOBILE_MODE: true,
    ENABLE_NATIVE_BRIDGE: true,
    ENABLE_DEBUG_TOOLS: false,
  },
  "app.bijen.app": {
    APP_ENV: "production",
    PUBLIC_WEB_URL: "https://app.bijen.app",
    PUBLIC_MOBILE_URL: "https://app.bijen.app",
    PUBLIC_API_URL: "",
    MOBILE_MODE: true,
    ENABLE_NATIVE_BRIDGE: true,
    ENABLE_DEBUG_TOOLS: false,
  },
};

function boolValue(value, fallback = false) {
  if (value === undefined || value === null || value === "") return fallback;
  if (typeof value === "boolean") return value;
  return ["1", "true", "yes", "on"].includes(String(value).toLowerCase());
}

function stripTrailingSlash(value) {
  return String(value || "").replace(/\/$/, "");
}

function runtimeConfig() {
  if (typeof window === "undefined") return {};
  return window.__HIVEFLOW_CONFIG__ || {};
}

function hostnameConfig() {
  if (typeof window === "undefined") return {};
  if (window.location.protocol === "file:" && window.ReactNativeWebView) {
    return {
      APP_ENV: "production",
      PUBLIC_WEB_URL: "https://app.bijen.app",
      PUBLIC_MOBILE_URL: "https://app.bijen.app",
      PUBLIC_API_URL: "https://app.bijen.app",
      MOBILE_MODE: true,
      ENABLE_NATIVE_BRIDGE: true,
      ENABLE_DEBUG_TOOLS: false,
      OFFLINE_BUNDLE: true,
    };
  }
  return HOST_CONFIG[window.location.hostname] || {};
}

const envConfig = {
  APP_ENV: process.env.REACT_APP_APP_ENV,
  PUBLIC_WEB_URL: process.env.REACT_APP_PUBLIC_WEB_URL,
  PUBLIC_MOBILE_URL: process.env.REACT_APP_PUBLIC_MOBILE_URL,
  PUBLIC_API_URL: process.env.REACT_APP_PUBLIC_API_URL || process.env.REACT_APP_BACKEND_URL,
  MOBILE_MODE: process.env.REACT_APP_MOBILE_MODE,
  ENABLE_NATIVE_BRIDGE: process.env.REACT_APP_ENABLE_NATIVE_BRIDGE,
  ENABLE_DEBUG_TOOLS: process.env.REACT_APP_ENABLE_DEBUG_TOOLS,
  OFFLINE_BUNDLE: process.env.REACT_APP_OFFLINE_BUNDLE,
};

function definedOnly(config) {
  return Object.fromEntries(
    Object.entries(config || {}).filter(([, value]) => value !== undefined && value !== null && value !== ""),
  );
}

export function getHiveflowConfig() {
  const fileBundle = typeof window !== "undefined" && window.location.protocol === "file:";
  const merged = {
    APP_ENV: "development",
    PUBLIC_WEB_URL: "",
    PUBLIC_MOBILE_URL: "",
    PUBLIC_API_URL: "",
    MOBILE_MODE: false,
    ENABLE_NATIVE_BRIDGE: false,
    ENABLE_DEBUG_TOOLS: false,
    ...hostnameConfig(),
    ...definedOnly(envConfig),
    ...definedOnly(runtimeConfig()),
  };
  if (fileBundle) {
    Object.assign(merged, {
      APP_ENV: "production",
      PUBLIC_WEB_URL: "https://app.bijen.app",
      PUBLIC_MOBILE_URL: "https://app.bijen.app",
      PUBLIC_API_URL: "https://app.bijen.app",
      MOBILE_MODE: true,
      ENABLE_NATIVE_BRIDGE: true,
      ENABLE_DEBUG_TOOLS: false,
      OFFLINE_BUNDLE: true,
    });
  }
  return {
    appEnv: merged.APP_ENV || "development",
    publicWebUrl: stripTrailingSlash(merged.PUBLIC_WEB_URL),
    publicMobileUrl: stripTrailingSlash(merged.PUBLIC_MOBILE_URL),
    publicApiUrl: stripTrailingSlash(merged.PUBLIC_API_URL),
    mobileMode: boolValue(merged.MOBILE_MODE),
    nativeBridgeEnabled: boolValue(merged.ENABLE_NATIVE_BRIDGE),
    debugToolsEnabled: boolValue(merged.ENABLE_DEBUG_TOOLS),
    offlineBundle: boolValue(merged.OFFLINE_BUNDLE) || fileBundle,
  };
}

export function isMobileMode() {
  return getHiveflowConfig().mobileMode;
}

export function isNativeBridgeAllowed() {
  const cfg = getHiveflowConfig();
  return cfg.mobileMode && cfg.nativeBridgeEnabled;
}

export function shouldRegisterServiceWorker() {
  const cfg = getHiveflowConfig();
  if (typeof window === "undefined" || process.env.NODE_ENV !== "production") return false;
  if (["localhost", "127.0.0.1"].includes(window.location.hostname)) return false;
  if (!['http:', 'https:'].includes(window.location.protocol)) return false;
  return cfg.appEnv === "production";
}
